export default __webpack_public_path__ + "static/media/B757.b5376b84.webp";